import React from 'react'

// Libraries
import { Col, Container, Row } from 'react-bootstrap'
import { Parallax } from "react-scroll-parallax";
import { m } from 'framer-motion'

// Components
import { fadeIn } from '../../Functions/GlobalAnimations';

// Data
import AllStory from '../../Components/Story/AllStory';

const AllStories = (props) => {
    return (
        <div style={props.style}>
            {/* Section Start */}
            <m.section
                    className="relative py-[30px] xs:px-0 px-[4.5rem] lg:px-[1.5rem] sm:px-0"
                    {...fadeIn}
                  >
                    <Container fluid>
                      <Row>
                        <Col className="text-center xs:px-0">
                            <AllStory filter={false} />
                        </Col>
                      </Row>
                    </Container>
                  </m.section>
            {/* Section End */}
        </div>
    )
}

export default AllStories
